module.exports = __webpack_public_path__ + "prs-europe-preview.jpg?af810f46636bb567fd78e24a70759685";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prs-europe-preview.jpg
// module id = 246
// module chunks = 0